// Homepage Banner Fade Slider
require("slick-carousel");

$(document).ready(function (evt) {
  slickFadeSlider();
});

function slickFadeSlider() {
  $(".c-homepage-banner__slides").slick({
    dots: true,
    infinite: true,
    // autoplay: true,
    autoplaySpeed: 6000,
    speed: 800,
    fade: true,
    cssEase: "linear",
    draggable: false,
    arrows: false,
    swipeToSlide: false,
  });
}
